/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StatusEnum = "assigned" | "draft" | "not_valid" | "pending" | "published" | "report_uploaded" | "verified" | "%future added value";
export type UploadStatusEnum = "cancelled" | "completed" | "failed" | "initiated" | "not_started" | "%future added value";
export type MarkJobRequestUploadFailedInput = {|
  clientMutationId?: ?string,
  jobRequestId: string,
|};
export type MarkJobRequestUploadFailedMutationVariables = {|
  input: MarkJobRequestUploadFailedInput
|};
export type MarkJobRequestUploadFailedMutationResponse = {|
  +markJobRequestUploadFailed: ?{|
    +jobRequest: ?{|
      +id: string,
      +uploadStatus: ?UploadStatusEnum,
      +status: ?StatusEnum,
    |}
  |}
|};
export type MarkJobRequestUploadFailedMutation = {|
  variables: MarkJobRequestUploadFailedMutationVariables,
  response: MarkJobRequestUploadFailedMutationResponse,
|};
*/


/*
mutation MarkJobRequestUploadFailedMutation(
  $input: MarkJobRequestUploadFailedInput!
) {
  markJobRequestUploadFailed(input: $input) {
    jobRequest {
      id
      uploadStatus
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkJobRequestUploadFailedPayload",
    "kind": "LinkedField",
    "name": "markJobRequestUploadFailed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JobRequest",
        "kind": "LinkedField",
        "name": "jobRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkJobRequestUploadFailedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkJobRequestUploadFailedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93bc73f77650705a9c5eeb923bf568b4",
    "id": null,
    "metadata": {},
    "name": "MarkJobRequestUploadFailedMutation",
    "operationKind": "mutation",
    "text": "mutation MarkJobRequestUploadFailedMutation(\n  $input: MarkJobRequestUploadFailedInput!\n) {\n  markJobRequestUploadFailed(input: $input) {\n    jobRequest {\n      id\n      uploadStatus\n      status\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ecc6bac3f419f4672d9ca5a16e5dd1f';

module.exports = node;
